import { render, staticRenderFns } from "./MemberDetailLink.vue?vue&type=template&id=26a26045&scoped=true&"
import script from "./MemberDetailLink.vue?vue&type=script&lang=js&"
export * from "./MemberDetailLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a26045",
  null
  
)

export default component.exports